import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlertsRoutingModule } from './alerts-routing.module';
import { AlertCallOfferComponent } from './components/alert-call-offer/alert-call-offer.component';
import { AlertJobOfferComponent } from './components/alert-job-offer/alert-job-offer.component';
import { AlertOtherComponent } from './components/alert-other/alert-other.component';


@NgModule({
  declarations: [
    AlertCallOfferComponent,
    AlertJobOfferComponent,
    AlertOtherComponent,
  ],
  imports: [
    CommonModule,
    AlertsRoutingModule
  ]
})
export class AlertsModule { }
